import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu } from 'lucide-react';
import skylarqLogo from '../../../assets/skylarq_logo_small.png';

interface MobileHeaderProps {
  onOpenMenu: () => void;
}

export const MobileHeader: React.FC<MobileHeaderProps> = ({ onOpenMenu }) => {
  const navigate = useNavigate();

  return (
    <div className="md:hidden fixed top-0 left-0 right-0 h-14 bg-white border-b border-neutral-200 z-40 flex items-center justify-between px-4">
      <button
        onClick={() => navigate('/datasets')}
        className="flex items-center gap-2"
        data-tour-home="mobile-logo"
      >
        <img src={skylarqLogo} alt="Skylarq" className="w-8 h-8 object-contain rounded-sm" />
        <span className="text-[15px] font-semibold text-neutral-900">Skylarq</span>
      </button>

      <button
        onClick={onOpenMenu}
        className="p-2 -mr-2 text-neutral-600 hover:text-neutral-900 hover:bg-neutral-100 rounded-lg transition"
        data-tour="mobile-menu-button"
      >
        <Menu className="w-6 h-6" />
      </button>
    </div>
  );
};
